import React from "react";
import '../Common.scss';
import defaultImage from '../../../assets/default.png';
import styles from './electricalElevation.module.scss';
export default class ElevationElectricals extends React.Component<any, any>{

    render() {
        const { pageDetails } = this.props;
        //const images = pageDetails['images'][0];
        const { electricalData, elevationImage, serviceAnnotationMapping } = pageDetails || {};
        return (
            <React.Fragment>
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage ? `${elevationImage}?ver=${new Date().getTime()}` :defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className={styles["tables-alignment"]} style={{marginTop: "15px", marginLeft: "10px"}}>
                    <div className={styles.Table}>
                        {/* <div class="Title">
                            <p>This is a Table</p>
                        </div> */}
                        <div className={styles.Heading}>
                            <div className={styles.Cell}>
                                <p><span className={styles['table-head']}>No</span></p>
                            </div>
                            <div className={styles.Cell}>
                                <p><span className={styles['table-head']}>DESCRIPTION</span></p>
                            </div>
                             <div className={styles.Cell}>
                                <p><span className={styles['table-head']+" "+styles['removePadding']}>POINT TYPE</span></p>
                            </div>
                            <div className={styles.Cell}>
                                <p><span className={styles['table-head']+" "+styles['removePadding']}>ADDITIONAL DETAILS</span></p>
                            </div>
                            {/*<div className={styles.Cell}>
                                <p><span className={styles['table-head']+" "+styles['removePadding']}>MODULE TYPE</span></p>
                            </div> */}
                        </div>
                        {
                            electricalData && electricalData.map(ele=>{
                                return(
                                    <div className={styles.Row}>
                                        <div className={styles.Cell}>
                                            <p><span className={styles['table-content']}>{ele["caption"].toString().toUpperCase()}</span></p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p><span className={styles['table-content']}>{ele["description"].toString().toUpperCase()}</span></p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p><span className={styles['table-content']}>{ele["pointType"].toString().toUpperCase()}</span></p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p><span className={styles['table-content']}>{''}</span></p>
                                        </div>
                                        {/*<div className={styles.Cell}>
                                            <p><span className={styles['table-content']}>{ele["moduleType"].toString().toUpperCase()}</span></p>
                                        </div> */}
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className={styles.Table}>
                            <div className={styles.Heading}>
                                <div className={styles.Cell}>
                                    <p><span className={styles['table-head']}>Annotation</span></p>
                                </div>
                                <div className={styles.Cell}>
                                    <p><span className={styles['table-head']}>Service Name</span></p>
                                </div>
                            </div>
                        {

                            serviceAnnotationMapping?.map(obj => {
                                return (
                                    <div className={styles.Row}>
                                    <div className={styles.Cell}>
                                        <p><span className={styles['table-content']}>{obj?.annotation}</span></p>
                                    </div>
                                    <div className={styles.Cell}>
                                        <p><span className={styles['table-content']}>{obj?.service}</span></p>
                                    </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    
                    {/* {
                        electricalNotifications && Object.keys(electricalNotifications) ?  <div className={styles.Table} style={{width: "25%"}}>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']} style={{borderRight: "none"}}>
                                    <p><span className={styles['table-head']}>ELECTRICAL NOTIFICATIONS</span></p>
                                </div>
                                <div className={styles.Cell} style={{borderLeft: "none"}}>
                                    <p></p>
                                </div>
                            </div>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']}>
                                    <p><span className={styles['table-head']}>SCOPE</span></p>
                                </div>
                                <div className={styles.Cell}>
                                    <p><span className={styles['table-content']}>{electricalNotifications['scope'] ? electricalNotifications['scope'].toString().toUpperCase(): "HOMELANE"}</span></p>
                                </div>
                            </div>
                        </div>  :""
                    } */}
                </div>
            </React.Fragment>

        )
    }

}